import type { IncomeChain } from '../IncomeVerification.types'

export const hasLargeDifferenceInput = (
	input?: number | null,
	amount?: number | null,
): boolean => {
	if (amount == null) return true
	const maxInputValue = amount * 1.1
	return (input ?? 0) > maxInputValue
}

export const emptyIncomeChain: IncomeChain = {
	id: 0,
	assessment: {
		value: null,
	},
	monthlyValue: 0,
	range: {
		min: 0,
		max: 0,
	},
	highVariability: false,
	transactions: [],
	typeOfIncome: null,
}

export const sortIncomeChainsByAssessmentValue = (
	incomeChainA: IncomeChain,
	incomeChainB: IncomeChain,
): number => {
	const assessmentA = incomeChainA.assessment?.value ?? Number.MIN_SAFE_INTEGER
	const assessmentB = incomeChainB.assessment?.value ?? Number.MIN_SAFE_INTEGER

	return assessmentA - assessmentB
}
